// DialogPaymentMessage Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'

import Dialog from '../../../common/layout/dialog/dialog.jsx'
import Button from '../../../common/common/button/button.jsx'
import FabButtonManager from '../../../lib/fabbuttonmanager.jsx'
import IntlMessage from '../../../common/common/intl/intl_message.jsx'

class DialogPaymentMessage extends Component {
  constructor (props) {
    super(props)

    this.state = {
      active: true,
      showErrorCont: true,
      title: '',
      message: ''
    }
  }

  static get propTypes () {
    return {
      onClose: PropTypes.func
    }
  }

  static get defaultProps () {
    return {
      onClose: null
    }
  }

  show (title, message, bError) {
    FabButtonManager.setVisible(false)
    this.setState({
      active: true,
      title: title,
      message: message,
      showErrorCont: !!bError
    })
  }

  hide () {
    FabButtonManager.setVisible(true)
    this.setState({
      active: false,
      title: '',
      message: '',
      showErrorCont: false
    })

    if (this.props.onClose) {
      this.props.onClose()
    }
  }

  render () {
    const classDialog = !this.state.showErrorCont
      ? 'dialogpayment-message'
      : 'dialogpayment-message showerr'
    const btnClass = !this.state.showErrorCont ? 'upgrade success' : 'upgrade'
    const title = this.state.title
    const message = this.state.message
    return (
      <Dialog
        active={this.state.active}
        onClose={this.hide.bind(this)}
        modal
      >
        <div className={classDialog}>
          <div className='paymentcont'>
            <div className='section'>
              <div className='title'>
                {title ? <IntlMessage ident={title} /> : ''}
              </div>
              <div className='info'>
                {message ? <IntlMessage ident={message} /> : ''}
              </div>
            </div>
          </div>
          <div className='paymentact'>
            <Button
              title='setting.subscription.actionClose'
              icon='common-success-tick'
              className={btnClass}
              canHover={false}
              onClick={this.hide.bind(this)}
            />
          </div>
        </div>
      </Dialog>
    )
  }
}

export default DialogPaymentMessage
